type Item = Record<string, any>;
const item = (value: unknown): Item => value && typeof value === "object" && !Array.isArray(value) ? value as Item : {};
const list = (value: unknown): Item[] => Array.isArray(value) ? value.map(item) : [];

/** Fill only compiled hooks; all payload values are text or validated image URLs. */
export const customStandingsContent = (root: HTMLElement, payload: unknown): DocumentFragment | null => {
  const templates = Object.fromEntries(["board", "row", "group", "mobile"].map((part) => [part, root.querySelector<HTMLTemplateElement>(`template[data-gwd-standing-${part}-template]`)]));
  if (!templates.board || !templates.row || !templates.group || !templates.mobile) return null;
  const data = item(item(payload).data ?? payload);
  const tables = list(item(data.table).tables);
  const teams = new Map(list(item(data.relation).teams).map((team) => [String(team.id), team]));
  const fill = (part: string, values: Record<string, unknown>, id?: string): DocumentFragment => {
    const fragment = templates[part]!.content.cloneNode(true) as DocumentFragment;
    Object.entries(values).forEach(([hook, value]) => {
      fragment.querySelectorAll<HTMLElement>(`[data-gwd-${hook}]`).forEach((node) => {
        if (node instanceof HTMLImageElement) {
          node.removeAttribute("src"); node.hidden = true;
          if (value) {
            try {
              const url = new URL(String(value), window.location.href);
              if (["https:", "http:"].includes(url.protocol)) { node.src = url.href; node.hidden = false; }
            } catch { /* Missing/invalid logos remain hidden. */ }
          }
        } else node.textContent = String(value ?? "");
      });
    });
    if (id) fragment.firstElementChild?.setAttribute("data-gwd-standing-id", id);
    return fragment;
  };
  const board = templates.board.content.cloneNode(true) as DocumentFragment;
  const desktop = board.querySelector<HTMLElement>("[data-gwd-list]");
  const mobile = board.querySelector<HTMLElement>("[data-gwd-mobile-list]");
  if (!desktop || !mobile) return null;
  tables.forEach((group, index) => {
    const rows = list(group.rows).sort((a, b) => Number(a.position || 0) - Number(b.position || 0));
    const number = Number(group.group ?? index);
    const name = tables.length === 1 ? "Đội bóng" : String(group.conference || `Bảng ${String.fromCharCode(65 + (Number.isFinite(number) ? Math.max(0, number) : index))}`);
    const header = { "group-title": name, "group-count": `${rows.length} đội` };
    desktop.append(fill("group", header)); mobile.append(fill("group", header));
    rows.forEach((row, rowIndex) => {
      const team = teams.get(String(row.teamId)) || {};
      const goals = row.goals ?? row.goal ?? "-";
      const values: Record<string, unknown> = {
        "standing-team": team.name || team.shortName || "-", "standing-logo": team.countryLogo || team.logo || "",
        "standing-rank": row.position || rowIndex + 1, "standing-goals": Array.isArray(goals) ? goals.join(":") : goals,
        "standing-difference": row.goalDiff ?? row.goalsDiff ?? "-", "standing-form": row.last5 || "-",
      };
      Object.entries({ played: "total", won: "won", draw: "draw", lost: "loss", points: "points" }).forEach(([hook, key]) => { values[`standing-${hook}`] = row[key] === "" ? 0 : (row[key] ?? 0); });
      const id = `${index}:${row.teamId ?? rowIndex}`;
      desktop.append(fill("row", values, id)); mobile.append(fill("mobile", values, id));
    });
  });
  if (!tables.length) [desktop, mobile].forEach((slot) => { const empty = document.createElement("p"); empty.className = "gwd-standings__empty"; empty.textContent = "Chưa có bảng xếp hạng."; slot.append(empty); });
  return board;
};
